import { gettext } from '@eventbrite/i18n';

export const COUNTRIES_REQUIRING_REGION = ['US', 'CA', 'IE', 'AU', 'BR'];
export const POSTAL_LABELS_BY_COUNTRY: Record<string, string> = {
    US: gettext('ZIP Code').toString(),
    DEFAULT: gettext('Postal Code').toString(),
};
export const POSTAL_ERROR_BY_COUNTRY: Record<string, string> = {
    US: gettext('ZIP Code is required').toString(),
    DEFAULT: gettext('Postal Code is required').toString(),
};
export const REGION_LABELS_BY_COUNTRY: Record<string, string> = {
    US: gettext('State').toString(),
    CA: gettext('Province').toString(),
    IE: gettext('County').toString(),
    AU: gettext('State/Territory').toString(),
    DEFAULT: gettext('State/Province').toString(),
};
export const REGION_ERROR_BY_COUNTRY: Record<string, string> = {
    US: gettext('State is required').toString(),
    CA: gettext('Province is required').toString(),
    IE: gettext('County is required').toString(),
    AU: gettext('State/Territory is required').toString(),
    DEFAULT: gettext('State/Province is required').toString(),
};
